import React, { useState } from "react";
import { motion } from "framer-motion";
import { Calendar, Clock, Send } from "lucide-react";

const Contacto = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    service: "",
    date: "",
    time: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, service, date, time } = formData;

    const startDate = new Date(`${date}T${time}`);
    const endDate = new Date(startDate.getTime() + 60 * 60 * 1000);

    const formatDate = (d) =>
      d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

    // LINK PARA ENVIAR CORREO
    const mailtoLink = `mailto:misticaura@email.com
      ?subject=Cita solicitada por ${name}
      &body=Nombre: ${name}%0D%0ACorreo: ${email}%0D%0AServicio: ${service}%0D%0AFecha: ${date}%0D%0AHora: ${time}`
      .replace(/\s+/g, "");

    // LINK PARA GOOGLE CALENDAR
    const googleCalendarLink =
      `https://calendar.google.com/calendar/render?action=TEMPLATE` +
      `&text=Cita: ${service}` +
      `&dates=${formatDate(startDate)}/${formatDate(endDate)}` +
      `&details=Nombre: ${name}%0D%0ACorreo: ${email}%0D%0AServicio: ${service}`;

    window.open(mailtoLink, "_blank");
    window.open(googleCalendarLink, "_blank");

    setFormData({
      name: "",
      email: "",
      service: "",
      date: "",
      time: "",
    });
  };

  return (
    <div className="pt-28 pb-20 bg-[#1E0B1A] text-yellow-300">
      <div className="container mx-auto px-6 max-w-3xl">
        
        {/* TÍTULO */}
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-center mb-6 bg-gradient-to-r from-red-400 to-yellow-400 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Agenda tu Cita
        </motion.h2>

        <p className="text-center text-yellow-300/80 mb-12">
          Selecciona tu fecha, hora y el tipo de consulta espiritual que deseas.
        </p>

        {/* FORMULARIO */}
        <motion.form
          onSubmit={handleSubmit}
          className="space-y-6 bg-black/20 p-8 rounded-2xl border border-red-500/30 shadow-lg"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
        >

          {/* Nombre */}
          <div>
            <label className="block mb-1 font-medium">Nombre Completo</label>
            <input
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
              className="w-full p-4 bg-black/30 border border-red-500/30 rounded-xl text-yellow-300 placeholder-yellow-400/40 focus:outline-none focus:border-red-500"
              placeholder="Tu nombre"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block mb-1 font-medium">Correo Electrónico</label>
            <input
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full p-4 bg-black/30 border border-red-500/30 rounded-xl text-yellow-300 placeholder-yellow-400/40 focus:outline-none focus:border-red-500"
              placeholder="email@ejemplo.com"
            />
          </div>

          {/* Servicio */}
          <div>
            <label className="block mb-1 font-medium">Tipo de Consulta</label>
            <select
              name="service"
              required
              value={formData.service}
              onChange={handleChange}
              className="w-full p-4 bg-black/30 border border-red-500/30 rounded-xl text-yellow-300 focus:outline-none focus:border-red-500"
            >
              <option value="">Selecciona una opción</option>
              <option>Limpieza espiritual</option>
              <option>Lectura de cartas</option>
              <option>Amarre</option>
              <option>Endulzamiento</option>
              <option>Alejamiento</option>
            </select>
          </div>

          {/* Fecha */}
          <div>
            <label className="block mb-1 font-medium flex items-center gap-2">
              <Calendar size={20} /> Fecha de la cita
            </label>
            <input
              type="date"
              name="date"
              required
              value={formData.date}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]}
              className="w-full p-4 bg-black/30 border border-red-500/30 rounded-xl text-yellow-300 focus:outline-none focus:border-red-500"
            />
          </div>

          {/* Hora */}
          <div>
            <label className="block mb-1 font-medium flex items-center gap-2">
              <Clock size={20} /> Hora de la cita
            </label>
            <input
              type="time"
              name="time"
              required
              value={formData.time}
              onChange={handleChange}
              className="w-full p-4 bg-black/30 border border-red-500/30 rounded-xl text-yellow-300 focus:outline-none focus:border-red-500"
            />
          </div>

          {/* BOTÓN */}
          <motion.button
            type="submit"
            className="w-full py-4 rounded-xl font-semibold text-yellow-300 bg-gradient-to-r from-red-600 to-black flex items-center justify-center gap-3 shadow-xl"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.95 }}
          >
            <Send size={22} className="text-yellow-400" />
            Confirmar y Agendar
          </motion.button>

        </motion.form>
      </div>
    </div>
  );
};

export default Contacto;
